module.exports = __webpack_public_path__ + "static/media/undraw_doll_play_evbw.1c561492.svg";